import React from 'react';
import { PageWrapper } from '../components/base';

const JoinByTextPage = () => (
  <PageWrapper title="Text Us">
    <section className="inner-width inner-width-padding section-first full-height column center text-center">
      <h2>Send us a text to keep in touch.</h2>
      <p>We can’t do this without you.</p>
      <button className="button primary">Send Us A Text</button>
    </section>
  </PageWrapper>
);

export default JoinByTextPage;
